import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Event, NavigationStart, NavigationEnd, NavigationError } from '@angular/router';
import { AuthloginService } from 'src/app/services/login/authlogin.service';
import { ConstantsModule } from 'src/app/common/constants/constants.module';
import { SubmitdataService } from 'src/app/services/submitdata/submitdata.service';
import { UtilsModule } from 'src/app/common/utils/utils.module';
import { isNullOrUndefined } from 'util';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-submitdata',
  templateUrl: './submitdata.component.html'
  // styleUrls: ['./submitdata.component.css']
})
export class SubmitdataComponent implements OnInit {
  lang;
  Urlparams;
  myObserver;
  userDetails;
  showindiawris : Boolean;
  setwindowstatus: any;
  multiyeardata: any;
  dateMsg : any;
  yearDropDownList: any;
  yearMonth : object = {ay : '',month:''}
  monthlist:{key: string, value:string}[] = [
    { key: '04' ,value: 'April'},
    { key: '05' ,value:'May'},
    { key: '06' ,value: 'June'},
    { key: '07' ,value:'July'},
    { key: '08' ,value: 'August'},
    { key: '09' ,value:'September'},
    { key: '10' ,value: 'October'},
    { key: '11' ,value:'November'},
    { key: '12' ,value: 'December'},
    { key: '01' ,value:'January'},
    { key: '02' ,value: 'February'},
    { key: '03' ,value:'March'},
    ];
  currentMonth: any;
  timeWindow;
  showMarque: boolean;
  constructor( private router: Router,
    private route: ActivatedRoute, private submitdataservice : SubmitdataService,
    private sessionlogin : AuthloginService,
    private translate : TranslateService,
    private utils : UtilsModule,
    private constants : ConstantsModule) { 
      translate.setDefaultLang("en")
      this.myObserver = this.router.events.subscribe((event: Event) => {
        if (event instanceof NavigationEnd) {
          this.initializeOnStateLoad();
        }
      });
    }

  ngOnInit() {
    this.Urlparams = this.route.snapshot.params;
    if(this.userDetails['roles'][0] == 'STATE_NODAL_OFFICER'){
    this.getWindowStatusAdmin();
    }
    if(this.userDetails['roles'][0] == 'DISTRICT_NODAL_OFFICER'){
      this.getWindowDistrict();
      }
    this.getYearListCurrentMonth();
    this.getTimeWindow();
  }
  getLanguage(event) {

    this.lang=event;
  }

  getYearListCurrentMonth(){
    let currentYear = new Date().getFullYear();
    let month = new Date().getMonth();
    let dropDownYear;
    if(month <3){
      dropDownYear = (currentYear - 1) + '-'+ currentYear;
    } else{
      dropDownYear = currentYear + '-'+ (currentYear + 1);
    }
    this.submitdataservice.getYearsToDisplay(this.submitdataservice.yearsPayload).subscribe(data=>{
      this.yearDropDownList = data['data'];      
    });
    this.yearMonth['ay'] = dropDownYear;

    let currentmonthObj;
    this.monthlist.forEach(monthObj => {
      if (parseInt(monthObj['key']) == month + 1) {
        currentmonthObj = monthObj;
      }
    });
    this.yearMonth['month'] = currentmonthObj['key'];
    this.currentMonth = currentmonthObj['value'];
  }

  getTimeWindow(){
    let locUid = this.userDetails['loggedUserData']['userProfile']['associatedlocationsDetails'][0]['entityUUID'];
    let year = this.yearMonth['ay']+"#"+this.yearMonth['month'];
    let postdata = {
      "childlist":  [locUid],
      "yearlist": [this.yearMonth['ay']],
      "monthlist":  [this.yearMonth['month']],
      "view":   this.constants.VIEWS['admin'],
      "cType": this.constants.LOCATION_CONSTANT['DISTRICT'],
      "pEUUID" :  this.userDetails['loggedUserData']['userProfile']['locationId']
    }
    this.submitdataservice.getWindowStatusData(postdata).subscribe(data=>{
      this.timeWindow = data[year][locUid];
      // console.log("timewindow",this.timeWindow);
      if(this.timeWindow['status'] == false){        
        this.showMarque = false;
      } else{
        this.showMarque = true;
      }
    });    
    
  }

  ngOnDestroy() {
    this.myObserver.unsubscribe();
  }
  initializeOnStateLoad(){
    this.Urlparams = this.route.snapshot.params;
    this.userDetails = this.sessionlogin.checkloginstatus();
    if(this.userDetails['roles'][0] == this.constants.USER_TYPES["VALIDATION_AGENCY"]){
      this.showindiawris = true;
    }else {
      this.showindiawris = false;
    }
  }
  async  getWindowStatusAdmin(){
    if(this.userDetails['roles'][0] == 'STATE_NODAL_OFFICER'){
    let options = {};
    options["isLocationNeeded"] =  false
    options['pEUUID'] = null;
    options["yearlist"] = this.submitdataservice.getassesmentYear(),
    options["view"] =  this.constants.VIEWS['admin'],
    options["cType"] =  this.constants.LOCATION_CONSTANT['STATE']
    this.setwindowstatus = await this.submitdataservice.getWindowStatus(options);
    if(this.setwindowstatus){
    Object.keys(this.setwindowstatus).forEach(year =>{
      if(!isNullOrUndefined(this.setwindowstatus[year])){
        this.multiyeardata = this.setwindowstatus[year]['edate'];
      }else{
        this.dateMsg = this.setwindowstatus[year]['msg'];
      }
     
    });
  }
}
     
}
async getWindowDistrict(){
  if(this.userDetails['roles'][0] == 'DISTRICT_NODAL_OFFICER'){
    let options = {};
    options["isLocationNeeded"] =  false;
    options['pEUUID'] = this.userDetails['roles'][0] ? this.userDetails['loggedUserData']['userProfile']['stateUUID']:null
    options["yearlist"] = this.yearDropDownList,
    options["view"] =  this.constants.VIEWS['admin'],
    options["cType"] =  this.constants.LOCATION_CONSTANT['DISTRICT']
    this.setwindowstatus = await this.submitdataservice.getWindowStatus(options);
    if(this.setwindowstatus){
    Object.keys(this.setwindowstatus).forEach(year =>{
      if(!isNullOrUndefined(this.setwindowstatus[year])){
        this.multiyeardata = this.setwindowstatus[year]['edate'];
      }
        this.dateMsg = this.setwindowstatus[year]['msg'];
      // }
    });

  }
}
     
}
formatdate(date){
  return this.utils.getDateInFormatFromModelDate(date.toString(),"dd-MM-yyyy")
}
  setcomponent(component){
    let params = {'component':component};
    this.router.navigate(["/submitdata",params]);

  }
  checkuserValid(type){
   if(this.userDetails && this.userDetails['accesssidetabs']){
     if(this.userDetails['accesssidetabs'].indexOf(type) >= 0)
      return true;
     else
      return false;  
   }else
    return false;
  }
  
}